import { Store } from 'vuex'
import { getModule } from 'vuex-module-decorators'
import AlertStore from '@/store/AlertStore'
import AppStore from '@/store/AppStore'
import AuthUserStore from '@/store/AuthUserStore'
import AuthorityStore from '@/store/AuthorityStore'
import BibliographyDetailSetStore from '@/store/BibliographyDetailSetStore'
import BibliographyDetailStore from '@/store/BibliographyDetailStore'
import BibliographySearchStore from '@/store/BibliographySearchStore'
import DataStore from '@/store/DataStore'
import DonorStore from '@/store/DonorStore'
import GlobalSystemParameterStore from '@/store/GlobalSystemParameterStore'
import LendStore from '@/store/LendStore'
import ModalAlertStore from '@/store/ModalAlertStore'
import ModalBibliographyDetailRealStore from '@/store/ModalBibliographyDetailRealStore'
import ModalBibliographyDetailSetStore from '@/store/ModalBibliographyDetailSetStore'
import ModalBibliographyDetailStore from '@/store/ModalBibliographyDetailStore'
import ModalBibliographySearchConditionStore from '@/store/ModalBibliographySearchConditionStore'
import ModalBibliographySearchHistoryStore from '@/store/ModalBibliographySearchHistoryStore'
import ModalBibliographySearchResultAuthorityStore from '@/store/ModalBibliographySearchResultAuthorityStore'
import ModalBibliographySearchResultContentStore from '@/store/ModalBibliographySearchResultContentStore'
import ModalBibliographySearchResultStore from '@/store/ModalBibliographySearchResultStore'
import ModalBibliographySearchStore from '@/store/ModalBibliographySearchStore'
import ModalBibliographyTagDataEditStore from '@/store/ModalBibliographyTagDataEditStore'
import ModalCodeKeyStore from '@/store/ModalCodeKeyStore'
import ModalCodeStore from '@/store/ModalCodeStore'
import ModalCollectionEditStore from '@/store/ModalCollectionEditStore'
import ModalCollectionSelectStore from '@/store/ModalCollectionSelectStore'
import ModalErrorStore from '@/store/ModalErrorStore'
import ModalJobListStore from '@/store/ModalJobListStore'
import ModalOrderEditStore from '@/store/ModalOrderEditStore'
import ModalProcessPlaceChangeStore from '@/store/ModalProcessPlaceChangeStore'
import ModalQuickMenuStore from '@/store/ModalQuickMenuStore'
import ModalReceiptHistoryStore from '@/store/ModalReceiptHistoryStore'
import ModalReturnHistoryStore from '@/store/ModalReturnHistoryStore'
import ModalShelfDiagramStore from '@/store/ModalShelfDiagramStore'
import ModalUpdateCollectionMemoStore from '@/store/ModalUpdateCollectionMemoStore'
import ModalUpdateOrderMemoStore from '@/store/ModalUpdateOrderMemoStore'
import ModalUserDetailStore from '@/store/ModalUserDetailStore'
import ModalUserSearchStore from '@/store/ModalUserSearchStore'
import PageStore from '@/store/PageStore'
import ReferenceImageMasterStore from '@/store/ReferenceImageMasterStore'
import ReferenceListStore from '@/store/ReferenceListStore'
import ReferenceStore from '@/store/ReferenceStore'
import ReservationContactPageStore from '@/store/ReservationContactPageStore'
import ReservationCandidateListStore from '@/store/ReservationCandidateListStore'
import ReturnPageStore from '@/store/ReturnPageStore'
import SystemCodeKeyStore from '@/store/SystemCodeKeyStore'
import SystemCodeStore from '@/store/SystemCodeStore'
import SystemParameterKeyStore from '@/store/SystemParameterKeyStore'
import SystemParameterStore from '@/store/SystemParameterStore'
import TraderStore from '@/store/TraderStore'
import UserStore from '@/store/UserStore'
import CollectionListStore from '@/store/CollectionListStore'
import ReWriteCardStore from '@/store/ReWriteCardStore'
import FelicaStore from '@/store/FelicaStore'
import ModalReturnCheckAlertStore from '@/store/ModalReturnCheckAlertStore'
import IcTagStore from '@/store/IcTagStore'

/* eslint import/no-mutable-exports: 0 */
let alertStore: AlertStore
let appStore: AppStore
let authorityStore: AuthorityStore
let authUserStore: AuthUserStore
let bibliographyDetailSetStore: BibliographyDetailSetStore
let bibliographyDetailStore: BibliographyDetailStore
let bibliographySearchStore: BibliographySearchStore
let collectionListStore: CollectionListStore
let dataStore: DataStore
let donorStore: DonorStore
let globalSystemParameterStore: GlobalSystemParameterStore
let lendStore: LendStore
let modalAlertStore: ModalAlertStore
let modalReturnCheckAlertStore: ModalReturnCheckAlertStore
let modalBibliographyDetailRealStore: ModalBibliographyDetailRealStore
let modalBibliographyDetailSetStore: ModalBibliographyDetailSetStore
let modalBibliographyDetailStore: ModalBibliographyDetailStore
let modalBibliographySearchConditionStore: ModalBibliographySearchConditionStore
let modalBibliographySearchHistoryStore: ModalBibliographySearchHistoryStore
let modalBibliographySearchResultAuthorityStore: ModalBibliographySearchResultAuthorityStore
let modalBibliographySearchResultContentStore: ModalBibliographySearchResultContentStore
let modalBibliographySearchResultStore: ModalBibliographySearchResultStore
let modalBibliographySearchStore: ModalBibliographySearchStore
let modalBibliographyTagDataEditStore: ModalBibliographyTagDataEditStore
let modalCodeKeyStore: ModalCodeKeyStore
let modalCodeStore: ModalCodeStore
let modalCollectionEditStore: ModalCollectionEditStore
let modalCollectionSelectStore: ModalCollectionSelectStore
let modalErrorStore: ModalErrorStore
let modalJobListStore: ModalJobListStore
let modalOrderEditStore: ModalOrderEditStore
let modalProcessPlaceChangeStore: ModalProcessPlaceChangeStore
let modalQuickMenuStore: ModalQuickMenuStore
let modalReceiptHistoryStore: ModalReceiptHistoryStore
let modalReturnHistoryStore: ModalReturnHistoryStore
let modalShelfDiagramStore: ModalShelfDiagramStore
let modalUpdateCollectionMemoStore: ModalUpdateCollectionMemoStore
let modalUpdateOrderMemoStore: ModalUpdateOrderMemoStore
let modalUserDetailStore: ModalUserDetailStore
let modalUserSearchStore: ModalUserSearchStore
let pageStore: PageStore
let referenceImageMasterStore: ReferenceImageMasterStore
let referenceListStore: ReferenceListStore
let referenceStore: ReferenceStore
let reservationCandidateListStore: ReservationCandidateListStore
let reservationContactPageStore: ReservationContactPageStore
let returnPageStore: ReturnPageStore
let reWriteCardStore: ReWriteCardStore
let systemCodeKeyStore: SystemCodeKeyStore
let systemCodeStore: SystemCodeStore
let systemParameterKeyStore: SystemParameterKeyStore
let systemParameterStore: SystemParameterStore
let traderStore: TraderStore
let userStore: UserStore
let felicaStore: FelicaStore
let icTagStore: IcTagStore

function initialiseStores(store: Store<any>): void {
  alertStore = getModule(AlertStore, store)
  appStore = getModule(AppStore, store)
  authorityStore = getModule(AuthorityStore, store)
  authUserStore = getModule(AuthUserStore, store)
  bibliographyDetailSetStore = getModule(BibliographyDetailSetStore, store)
  bibliographyDetailStore = getModule(BibliographyDetailStore, store)
  bibliographySearchStore = getModule(BibliographySearchStore, store)
  collectionListStore = getModule(CollectionListStore, store)
  dataStore = getModule(DataStore, store)
  donorStore = getModule(DonorStore, store)
  globalSystemParameterStore = getModule(GlobalSystemParameterStore, store)
  lendStore = getModule(LendStore, store)
  modalAlertStore = getModule(ModalAlertStore, store)
  modalReturnCheckAlertStore = getModule(ModalReturnCheckAlertStore, store)
  modalBibliographyDetailRealStore = getModule(
    ModalBibliographyDetailRealStore,
    store
  )
  modalBibliographyDetailSetStore = getModule(
    ModalBibliographyDetailSetStore,
    store
  )
  modalBibliographyDetailStore = getModule(ModalBibliographyDetailStore, store)
  modalBibliographySearchConditionStore = getModule(
    ModalBibliographySearchConditionStore,
    store
  )
  modalBibliographySearchHistoryStore = getModule(
    ModalBibliographySearchHistoryStore,
    store
  )
  modalBibliographySearchResultAuthorityStore = getModule(
    ModalBibliographySearchResultAuthorityStore,
    store
  )
  modalBibliographySearchResultContentStore = getModule(
    ModalBibliographySearchResultContentStore,
    store
  )
  modalBibliographySearchResultStore = getModule(
    ModalBibliographySearchResultStore,
    store
  )
  modalBibliographySearchStore = getModule(ModalBibliographySearchStore, store)
  modalBibliographyTagDataEditStore = getModule(
    ModalBibliographyTagDataEditStore,
    store
  )
  modalCodeKeyStore = getModule(ModalCodeKeyStore, store)
  modalCodeStore = getModule(ModalCodeStore, store)
  modalCollectionEditStore = getModule(ModalCollectionEditStore, store)
  modalCollectionSelectStore = getModule(ModalCollectionSelectStore, store)
  modalErrorStore = getModule(ModalErrorStore, store)
  modalJobListStore = getModule(ModalJobListStore, store)
  modalOrderEditStore = getModule(ModalOrderEditStore, store)
  modalProcessPlaceChangeStore = getModule(ModalProcessPlaceChangeStore, store)
  modalQuickMenuStore = getModule(ModalQuickMenuStore, store)
  modalReceiptHistoryStore = getModule(ModalReceiptHistoryStore, store)
  modalReturnHistoryStore = getModule(ModalReturnHistoryStore, store)
  modalShelfDiagramStore = getModule(ModalShelfDiagramStore, store)
  modalUpdateCollectionMemoStore = getModule(
    ModalUpdateCollectionMemoStore,
    store
  )
  modalUpdateOrderMemoStore = getModule(ModalUpdateOrderMemoStore, store)
  modalUserDetailStore = getModule(ModalUserDetailStore, store)
  modalUserSearchStore = getModule(ModalUserSearchStore, store)
  pageStore = getModule(PageStore, store)
  referenceImageMasterStore = getModule(ReferenceImageMasterStore, store)
  referenceListStore = getModule(ReferenceListStore, store)
  referenceStore = getModule(ReferenceStore, store)
  reservationCandidateListStore = getModule(
    ReservationCandidateListStore,
    store
  )
  reservationContactPageStore = getModule(ReservationContactPageStore, store)
  returnPageStore = getModule(ReturnPageStore, store)
  reWriteCardStore = getModule(ReWriteCardStore, store)
  systemCodeKeyStore = getModule(SystemCodeKeyStore, store)
  systemCodeStore = getModule(SystemCodeStore, store)
  systemParameterKeyStore = getModule(SystemParameterKeyStore, store)
  systemParameterStore = getModule(SystemParameterStore, store)
  traderStore = getModule(TraderStore, store)
  userStore = getModule(UserStore, store)
  felicaStore = getModule(FelicaStore, store)
  icTagStore = getModule(IcTagStore, store)
}

export {
  alertStore,
  appStore,
  authorityStore,
  authUserStore,
  bibliographyDetailSetStore,
  bibliographyDetailStore,
  bibliographySearchStore,
  collectionListStore,
  dataStore,
  donorStore,
  globalSystemParameterStore,
  initialiseStores,
  lendStore,
  modalAlertStore,
  modalReturnCheckAlertStore,
  modalBibliographyDetailRealStore,
  modalBibliographyDetailSetStore,
  modalBibliographyDetailStore,
  modalBibliographySearchConditionStore,
  modalBibliographySearchHistoryStore,
  modalBibliographySearchResultAuthorityStore,
  modalBibliographySearchResultContentStore,
  modalBibliographySearchResultStore,
  modalBibliographySearchStore,
  modalBibliographyTagDataEditStore,
  modalCodeKeyStore,
  modalCodeStore,
  modalCollectionEditStore,
  modalCollectionSelectStore,
  modalErrorStore,
  modalJobListStore,
  modalOrderEditStore,
  modalProcessPlaceChangeStore,
  modalQuickMenuStore,
  modalReceiptHistoryStore,
  modalReturnHistoryStore,
  modalShelfDiagramStore,
  modalUpdateCollectionMemoStore,
  modalUpdateOrderMemoStore,
  modalUserDetailStore,
  modalUserSearchStore,
  pageStore,
  referenceImageMasterStore,
  referenceListStore,
  referenceStore,
  reservationCandidateListStore,
  reservationContactPageStore,
  returnPageStore,
  reWriteCardStore,
  systemCodeKeyStore,
  systemCodeStore,
  systemParameterKeyStore,
  systemParameterStore,
  traderStore,
  userStore,
  felicaStore,
  icTagStore
}
